import { kloString, pvmStringLong } from "src/components/js/statics1";
import { betoni_getString } from "../betoni/BetoniFunctions";

/**
 *
 * @param {keikkaClass} keikkaData
 * @param {keikkaClass} origKeikkaData
 * @returns {changeHandler}
 * @description returns a changeHandler object that represents changes between two keikkaClass objects
 *
 */
export default class changeHandler {
  constructor(keikkaData, origKeikkaData) {
    this.keikkaData = keikkaData;
    this.origKeikkaData = origKeikkaData;
    this.nullReturn = { origStr: null, newStr: null, changeString: null, changed: false };
  }
  get getAikaKestoChange() {
    const origTime = this.origKeikkaData.pumppu.pumppuAika;
    const newTime = this.keikkaData.pumppu.pumppuAika;
    const origDateString = pvmStringLong(this.origKeikkaData.pumppu.pumppuAika);
    const newDateString = pvmStringLong(this.keikkaData.pumppu.pumppuAika);
    const origTimeString = kloString(new Date(this.origKeikkaData.pumppu.pumppuAika));
    const newTimeString = kloString(this.keikkaData.pumppu.pumppuAika);

    const origKesto_h = this.origKeikkaData.pumppu.pumppuKesto / 60;
    const newKesto_h = this.keikkaData.pumppu.pumppuKesto / 60;

    if (origTime === newTime && origKesto_h === newKesto_h) return this.nullReturn;

    let changeString = "";
    if (origDateString !== newDateString)
      changeString += "Päiväys: " + origDateString + " -> " + newDateString + "\n";
    if (origTimeString !== newTimeString)
      changeString += "Aloitusaika: " + origTimeString + " -> " + newTimeString + "\n";
    if (origKesto_h !== newKesto_h)
      changeString += "Kesto: " + origKesto_h + "h -> " + newKesto_h + "h\n";

    if (changeString.length > 1)
      return {
        origString: origDateString + " " + origKesto_h + "h",
        newString: newDateString + " " + newKesto_h + "h",
        changeString: changeString,
        changed: true,
      };
    else return this.nullReturn;
  }
  get getTyomaaChange() {
    let changeString = "";
    if (
      this.origKeikkaData.tyomaa.tyomaaOsoite1 !== this.keikkaData.tyomaa.tyomaaOsoite1 ||
      this.origKeikkaData.tyomaa.tyomaaOsoite2 !== this.keikkaData.tyomaa.tyomaaOsoite2 ||
      this.origKeikkaData.tyomaa.tyomaaOsoite3 !== this.keikkaData.tyomaa.tyomaaOsoite3 ||
      this.origKeikkaData.tyomaa.tyomaaOsoite4 !== this.keikkaData.tyomaa.tyomaaOsoite4
    )
      changeString +=
        "Uusi toimitusssoite: " +
        this.keikkaData.tyomaa.tyomaaOsoite1 +
        " " +
        this.keikkaData.tyomaa.tyomaaOsoite2 +
        " " +
        this.keikkaData.tyomaa.tyomaaOsoite3 +
        " " +
        this.keikkaData.tyomaa.tyomaaOsoite4 +
        "\n";

    if (this.origKeikkaData.tyomaa.keikkaAjoOhje !== this.keikkaData.tyomaa.keikkaAjoOhje)
      changeString += "Ajo-ohje: " + this.keikkaData.tyomaa.keikkaAjoOhje + "\n";

    if (changeString.length > 1)
      return {
        origString: "",
        newString: "",
        changeString: changeString,
        changed: true,
      };
    return this.nullReturn;
  }
  get getAsiakasChange() {
    let changeString = "";
    if (this.origKeikkaData.asiakas.asiakasNimi !== this.keikkaData.asiakas.asiakasNimi)
      changeString += "Asiakas vaihdettu: " + this.keikkaData.asiakas.asiakasNimi + "\n";
    else return this.nullReturn;
    return {
      origString: this.origKeikkaData.asiakas.asiakasNimi,
      newString: this.keikkaData.asiakas.asiakasNimi,
      changeString: changeString,
      changed: true,
    };
  }
  get getPuomiLinjaChange() {
    const puomiChanged =
      this.origKeikkaData.pumppu.pumppuPuomi !== this.keikkaData.pumppu.pumppuPuomi;
    const linjaChanged =
      this.origKeikkaData.pumppu.pumppuLinja !== this.keikkaData.pumppu.pumppuLinja;
    if (!puomiChanged && !linjaChanged) return this.nullReturn;

    const getNewString = () => {
      let c = "";
      if (puomiChanged) c += "P" + this.keikkaData.pumppu.pumppuPuomi + " ";
      if (linjaChanged) c += this.keikkaData.pumppu.pumppuLinja + "m";
      return c;
    };
    const getOrigString = () => {
      let c = "";
      if (puomiChanged) c += "P" + this.origKeikkaData.pumppu.pumppuPuomi + " ";
      if (linjaChanged) c += this.origKeikkaData.pumppu.pumppuLinja + "m";
      return c;
    };
    let changeString = "";
    if (puomiChanged)
      changeString += "Puomi vaihdettu: " + this.keikkaData.pumppu.pumppuPuomi + "m\n";
    if (linjaChanged)
      changeString += "Linja vaihdettu: " + this.keikkaData.pumppu.pumppuLinja + "m\n";
    return {
      origString: getOrigString(),
      newString: getNewString(),
      changeString: changeString,
      changed: true,
    };
  }
  get getBetoniLaatuChange() {
    let changeString = "";
    const origBetoniLaatu = betoni_getString(this.origKeikkaData.betoni);
    const newBetoniLaatu = betoni_getString(this.keikkaData.betoni);
    if (origBetoniLaatu !== newBetoniLaatu)
      changeString += "Betoni laatu vaihdettu: " + this.keikkaData.betoni.betoniLaatu + "\n";
    else return this.nullReturn;
    return {
      origString: origBetoniLaatu,
      newString: newBetoniLaatu,
      changeString: changeString,
      changed: true,
    };
  }
}

// sends a notification to all users who have access to this keikka
export async function sendNotificationsToKeikkaUsers(data, socket) {
  // kaikki data on oltava tässä muodossa
  // kaikki data on vastaanottajan firebase ilmoituksn payload.data kentässä
  // data.title, data.body, data.url, data.keikkaId, data.personId, data.icon
  // send socket command server to send notifications to keikka users
  socket.emit("sendNotificationsToKeikkaUsers", data);
}
